import axios from 'axios';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { OctResponse } from '../../models/OctResponse';
import { localStorageItem } from '../../utils/LocalStorage';
import { APP_CONFIGURATION_KEYS } from '../../utils/Constant';
import { CategoryInfoResponse, CategoryUploadResponse } from '../types/CategoryTypes';

const INS_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INS_URL];

console.log('[CategoryService] INS_URL:', INS_URL);

/**
 * Upload danh mục Excel files với progress tracking
 *
 * @param files - Danh sách files Excel
 * @param overwrite - Có ghi đè file cũ không
 * @param validateAfterUpload - Có validate sau upload không
 * @param onProgress - Callback để track progress
 * @param signal - AbortSignal để cancel upload
 * @returns Response với thông tin upload
 */
export const uploadCategories = async (
	files: File[],
	overwrite: boolean = true,
	validateAfterUpload: boolean = false,
	onProgress?: (progressEvent: any) => void,
	signal?: AbortSignal
): Promise<OctResponse<CategoryUploadResponse>> => {
	const formData = new FormData();

	// Append tất cả files vào FormData
	files.forEach((file) => {
		formData.append('files', file);
	});

	const { data } = await axios.post<OctResponse<CategoryUploadResponse>>(
		`${INS_URL}/xml/category/upload`,
		formData,
		{
			params: {
				overwrite,
				validateAfterUpload,
			},
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			onUploadProgress: onProgress,
			signal,
		}
	);

	return data;
};

/**
 * Lấy thông tin danh mục đã upload
 *
 * @returns Thông tin danh mục của tenant hiện tại
 */
export const getCategoryInfo = async (): Promise<OctResponse<CategoryInfoResponse>> => {
	const { data } = await axios.get<OctResponse<CategoryInfoResponse>>(
		`${INS_URL}/xml/category/info`
	);
	return data;
};

/**
 * Xóa toàn bộ danh mục
 *
 * @returns Response
 */
export const deleteAllCategories = async (): Promise<OctResponse<string>> => {
	const { data } = await axios.delete<OctResponse<string>>(`${INS_URL}/xml/category/all`);
	return data;
};

/**
 * Upload 1 file danh mục đơn lẻ với progress tracking
 *
 * @param file - File Excel cần upload
 * @param overwrite - Có ghi đè file cũ không
 * @param onProgress - Callback để track progress của file này
 * @param signal - AbortSignal để cancel upload
 * @returns Response với thông tin upload
 */
export const uploadSingleCategory = async (
	file: File,
	overwrite: boolean = true,
	onProgress?: (progressEvent: any) => void,
	signal?: AbortSignal
): Promise<OctResponse<CategoryUploadResponse>> => {
	const formData = new FormData();
	formData.append('files', file);

	const { data } = await axios.post<OctResponse<CategoryUploadResponse>>(
		`${INS_URL}/xml/category/upload`,
		formData,
		{
			params: {
				overwrite,
				validateAfterUpload: false,
			},
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			onUploadProgress: onProgress,
			signal,
		}
	);

	return data;
};

/**
 * Xóa 1 file danh mục cụ thể
 *
 * @param fileName - Tên file cần xóa
 * @returns Response
 */
export const deleteCategory = async (fileName: string): Promise<OctResponse<string>> => {
	const { data } = await axios.delete<OctResponse<string>>(
		`${INS_URL}/xml/category/${encodeURIComponent(fileName)}`
	);
	return data;
};
